import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { CultureSection } from './components/CultureSection';
import { ContactSection } from './components/ContactSection';
import { MarqueeStrip } from './components/MarqueeStrip';
export function App() {
  return <div className="min-h-screen bg-tux-dark text-white relative" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <MarqueeStrip data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <CultureSection data-id="element-6" />
      </main>
      <ContactSection data-id="element-7" />
    </div>;
}